<template lang="pug">
  .content
    .md-layout.md-gutter.md-alignment-center-center
      .md-layout-item.md-size-40.md-medium-size-55.md-xsmall-size-100
        form(@submit.prevent="" autocomplete="on")
          md-card
            md-card-header(data-background-color="green")
              h4(class="title") Password Reset
              p(class="category") Reset your USIT Portal password.
            md-card-content
              .md-layout
                .md-layout-item.md-size-100
                  md-field
                    md-icon person
                    label UT EID
                    md-input(v-model="eid" type="text" required autocomplete="username")
                .text-center.md-layout-item
                  h6(v-if="error" style="color: red") Sorry, there was an error sending your reset email. Please try again.
                  h6(v-if="success") You should receive an email with a link to reset your password!
                  md-button(type="submit" v-on:click="sendPasswordReset") Send Reset email
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      eid: '',
      error: null,
      success: null,
    };
  },
  methods: {
    sendPasswordReset() {
      this.resetError = null;
      this.success = null;
      
      axios.post('/api/sendpasswordreset', {eid: this.eid})
      .then((response) => {
        this.success = true;
      }).catch((error) => {
        this.error = true;
      });
    }
  }
}
</script>

<style scoped>
  form{
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/LoginPasswordReset.vue